import { db } from '../../config/firebase'

const deleteDoc = ({ path, docId }) => db.collection(path).doc(docId).delete().then(() => docId)

export default deleteDoc
